import React from 'react';
import cx from 'classnames';
import { Divider } from 'antd';
import { Button, Segment } from 'semantic-ui-react';
import { observer } from 'mobx-react';

import '../AddEditClinic/index.scss';
import './index.scss';

import Progress from './Progress';
import ClaimDetails from './ClaimDetails';
import AppointmentDetailsAndCaseDocuments from './AppointmentDetailsAndCaseDocuments';
import AppointmentReminder from './AppointmentReminder';
import AppointmentAttendanceAndCaseCancellation from './AppointmentAttendanceAndCaseCancellation';
import DictationsAndReportInformation from './DictationsAndReportInformation';
import SpecialistPaymentInformation from './SpecialistPaymentInformation';
import ClientInvoicingInformation from './ClientInvoicingInformation';
import CaseCorrespondence from './CaseCorrespondence';
import ActionRequired from './ActionRequired';
import FormDragToDropFile from './FormDragToDropFile';
import AddEditStore from './Store';

@observer
class AddEditImeAssessments extends React.Component {
  state = {
    currentStep: 0,
  };

  updateDimensions = () => {
    console.log(window.innerWidth);
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    AddEditStore.fetchAssessmentInfo(0);
  }

  handleStepChange = step => () => {
    AddEditStore.handleActiveUploadType(step, true);
    this.setState({ currentStep: step });
  };

  renderForm = () => {
    switch (this.state.currentStep) {
      case 1:
        return <AppointmentDetailsAndCaseDocuments />;
      case 2:
        return <AppointmentReminder />;
      case 3:
        return <AppointmentAttendanceAndCaseCancellation />;
      case 4:
        return <DictationsAndReportInformation />;
      case 5:
        return <SpecialistPaymentInformation />;
      case 6:
        return <ClientInvoicingInformation />;
      case 7:
        return <CaseCorrespondence />;
      case 8:
        return <ActionRequired />;
      default:
        return <ClaimDetails />;
    }
  };

  render() {
    return (
      <div className="page-container">
        <Progress />
        <div className="form-container">
          <h1 className="form-title">
            {AddEditStore.steps[this.state.currentStep].title}
          </h1>
          {this.renderForm()}
        </div>
        <div className="step-container">
          {AddEditStore.steps.map((step, idx) => (
            <Button
              key={step.key}
              fluid
              size="large"
              className={cx('step', { active: this.state.currentStep === idx })}
              onClick={this.handleStepChange(idx)}
            >
              {idx + 1}. {step.title}
            </Button>
          ))}
          {!!AddEditStore.upLoadType.filter(i => i.active).length && (
            <Divider />
          )}
          {AddEditStore.upLoadType
            .filter(i => i.active)
            .map((i, idx) => (
              <div key={i.key} style={{ marginBottom: '30px' }}>
                <Segment className="drag-drop-file">
                  <span className="drag-drop-file-title">
                    {i.title ? i.title.toUpperCase() : i.fileName.toUpperCase()}
                  </span>
                </Segment>
                <FormDragToDropFile
                  fileName={i.fileName.toLowerCase()}
                  fileType={i.reportType}
                />
                {idx <
                  AddEditStore.upLoadType.filter(i => i.active).length - 1 && (
                  <Divider />
                )}
              </div>
            ))}
        </div>
        <div className="form-footer">
          <Divider />
          <Button primary>Save</Button>
          <Button className="negative">Close</Button>
        </div>
      </div>
    );
  }
}

export default AddEditImeAssessments;
